import { gql } from '@apollo/client'

export const ADD_STORES_TO_ZONE = gql`
  mutation AddStoresToZone($input: UpdateZoneInput!) {
    addStoresToZone(input: $input) {
      success
    }
  }
`
